import Vue from 'vue'
import Router from 'vue-router'
import RecuperarSenha from '@/components/RecuperarSenha'
import { isMobile } from 'mobile-device-detect';

Vue.use(Router)

var _this = new Router({
	// mode: 'history',
  	routes: [ 
	    { 
	    	path: '/',
			beforeEnter(to, from, next) {
		        // Put the full page URL including the protocol http(s) below
		        window.close();
		    },	    	 
	      	name: 'Inicio',
	      	meta: {
	      		title: 		""
	      	},	    	
	    },
	    {
	      	path: '/recuperar-senha/',
	      	name: 'RecuperarSenha',
	      	meta: {
	      		title: 		"Recuperar senha",
	      		auth: 		false,
	      	},
	      	component: RecuperarSenha
	    },	            	    		    	           
	    { path: '*', redirect: '/' }
  	]
})

export default _this;


// WEBPACK FOOTER //
// ./src/router/index.js